import React from "react";

import {

    Document,

    Page,

    Text,

    View,

    Image,

    StyleSheet,

    Font

} from "@react-pdf/renderer";


/*
|--------------------------------------------------------------------------
| PDF STYLES
|--------------------------------------------------------------------------
*/

const styles = StyleSheet.create({

    page: {

        paddingTop: 35,

        paddingBottom: 35,

        paddingLeft: 40,

        paddingRight: 40,

        fontFamily: "Helvetica",

        backgroundColor: "#ffffff"

    },


    header: {

        flexDirection: "row",

        alignItems: "center",

        borderBottomWidth: 2,

        borderBottomColor: "#5b0018",

        paddingBottom: 12,

        marginBottom: 18

    },


    logo: {

        width: 65,

        height: 65,

        objectFit: "contain",

        marginRight: 15

    },


    schoolInformation: {

        flex: 1,

        alignItems: "center"

    },


    schoolName: {

        fontSize: 20,

        fontWeight: "bold",

        color: "#1c1416",

        textTransform: "uppercase"

    },


    reportTitle: {

        fontSize: 13,

        marginTop: 5,

        fontWeight: "bold",

        color: "#333333"

    },


    academicYear: {

        fontSize: 10,

        marginTop: 4,

        color: "#555555"

    },


    reportInformation: {

        flexDirection: "row",

        justifyContent: "space-between",

        backgroundColor: "#f4f5f7",

        borderWidth: 1,

        borderColor: "#dedfe2",

        padding: 10,

        marginBottom: 18

    },


    reportInfoItem: {

        flexDirection: "row"

    },


    reportInfoLabel: {

        fontSize: 9,

        fontWeight: "bold",

        color: "#555555",

        marginRight: 4

    },


    reportInfoValue: {

        fontSize: 9,

        color: "#222222"

    },


    summaryContainer: {

        flexDirection: "row",

        marginBottom: 18

    },


    summaryBox: {

        flex: 1,

        padding: 10,

        marginRight: 8,

        borderWidth: 1,

        borderColor: "#dedfe2",

        backgroundColor: "#fafafa"

    },


    summaryBoxLast: {

        flex: 1,

        padding: 10,

        borderWidth: 1,

        borderColor: "#dedfe2",

        backgroundColor: "#fafafa"

    },


    summaryLabel: {

        fontSize: 8,

        color: "#666666"

    },


    summaryValue: {

        fontSize: 16,

        fontWeight: "bold",

        color: "#171315",

        marginTop: 4

    },


    section: {

        marginBottom: 18

    },


    sectionHeader: {

        flexDirection: "row",

        justifyContent: "space-between",

        alignItems: "center",

        backgroundColor: "#201d1e",

        color: "#ffffff",

        padding: 8

    },


    sectionTitle: {

        fontSize: 10,

        fontWeight: "bold",

        color: "#ffffff"

    },


    sectionCount: {

        fontSize: 9,

        color: "#ffffff"

    },


    tableHeader: {

        flexDirection: "row",

        backgroundColor: "#eeeeee",

        borderLeftWidth: 1,

        borderRightWidth: 1,

        borderBottomWidth: 1,

        borderColor: "#d5d5d5",

        paddingVertical: 6

    },


    tableRow: {

        flexDirection: "row",

        borderLeftWidth: 1,

        borderRightWidth: 1,

        borderBottomWidth: 1,

        borderColor: "#e1e1e1",

        paddingVertical: 6

    },


    numberColumn: {

        width: "8%",

        paddingLeft: 8,

        fontSize: 8

    },


    nameColumn: {

        width: "40%",

        fontSize: 8

    },


    genderColumn: {

        width: "15%",

        fontSize: 8

    },


    divisionColumn: {

        width: "22%",

        fontSize: 8

    },


    statusColumn: {

        width: "15%",

        fontSize: 8

    },


    tableHeaderText: {

        fontSize: 8,

        fontWeight: "bold",

        color: "#333333"

    },


    emptyText: {

        fontSize: 9,

        color: "#777777",

        padding: 10,

        textAlign: "center",

        borderWidth: 1,

        borderColor: "#e1e1e1"

    },


    footer: {

        position: "absolute",

        bottom: 18,

        left: 40,

        right: 40,

        flexDirection: "row",

        justifyContent: "space-between",

        borderTopWidth: 1,

        borderTopColor: "#dddddd",

        paddingTop: 6

    },


    footerText: {

        fontSize: 8,

        color: "#777777"

    }

});


/*
|--------------------------------------------------------------------------
| SORT STUDENTS ALPHABETICALLY
|--------------------------------------------------------------------------
*/

const sortStudentsAlphabetically = (students = []) => {

    return [...students].sort(

        (a, b) =>

            (a.full_name || "").localeCompare(

                b.full_name || "",

                undefined,

                {

                    sensitivity: "base"

                }

            )

    );

};


/*
|--------------------------------------------------------------------------
| STUDENT STATUS SECTION
|--------------------------------------------------------------------------
*/

const StudentStatusSection = ({

    title,

    students

}) => {

    const sortedStudents =
        sortStudentsAlphabetically(
            students
        );


    return (

        <View

            style={styles.section}

            wrap={false}

        >

            <View style={styles.sectionHeader}>

                <Text style={styles.sectionTitle}>

                    {title.toUpperCase()}

                </Text>


                <Text style={styles.sectionCount}>

                    {sortedStudents.length} Student

                    {sortedStudents.length !== 1
                        ? "s"
                        : ""}

                </Text>

            </View>


            {sortedStudents.length === 0 ? (

                <Text style={styles.emptyText}>

                    No students in this category.

                </Text>

            ) : (

                <>

                    <View style={styles.tableHeader}>

                        <Text

                            style={[

                                styles.numberColumn,

                                styles.tableHeaderText

                            ]}

                        >

                            #

                        </Text>


                        <Text

                            style={[

                                styles.nameColumn,

                                styles.tableHeaderText

                            ]}

                        >

                            STUDENT NAME

                        </Text>


                        <Text

                            style={[

                                styles.genderColumn,

                                styles.tableHeaderText

                            ]}

                        >

                            GENDER

                        </Text>


                        <Text

                            style={[

                                styles.divisionColumn,

                                styles.tableHeaderText

                            ]}

                        >

                            DIVISION

                        </Text>


                        <Text

                            style={[

                                styles.statusColumn,

                                styles.tableHeaderText

                            ]}

                        >

                            STATUS

                        </Text>

                    </View>


                    {sortedStudents.map(

                        (student, index) => (

                            <View

                                key={student.id}

                                style={styles.tableRow}

                                wrap={false}

                            >

                                <Text

                                    style={styles.numberColumn}

                                >

                                    {index + 1}

                                </Text>


                                <Text

                                    style={styles.nameColumn}

                                >

                                    {student.full_name ||

                                        "Unnamed Student"}

                                </Text>


                                <Text

                                    style={styles.genderColumn}

                                >

                                    {student.gender ||

                                        "N/A"}

                                </Text>


                                <Text

                                    style={styles.divisionColumn}

                                >

                                    {student.division ||

                                        "Unassigned"}

                                </Text>


                                <Text

                                    style={styles.statusColumn}

                                >

                                    {student.student_status ||

                                        title}

                                </Text>

                            </View>

                        )

                    )}

                </>

            )}

        </View>

    );

};


/*
|--------------------------------------------------------------------------
| MAIN PDF
|--------------------------------------------------------------------------
*/

const StudentStatusSummaryPDF = ({

   
    schoolName = "Excellent Kids Foundation",

    logo,

    academicYear,

    gradeClass

}) => {


    const students =
        gradeClass?.students || [];


    const regularStudents =
        students.filter(

            student =>

                student.student_status ===
                "Regular"

        );


    const dependentStudents =
        students.filter(

            student =>

                student.student_status ===
                "Dependent"

        );


    const scholarshipStudents =
        students.filter(

            student =>

                student.student_status ===
                "Scholarship"

        );


    return (

        <Document

            title={`Student Status Statistics - ${gradeClass?.grade_class}`}

            author={schoolName}

            subject="Student Status Statistics - Polu Integrated Technology"

        >

            <Page

                size="A4"

                orientation="landscape"

                style={styles.page}

            >

                {/* HEADER */}

                <View style={styles.header}>

                    {logo && (

                        <Image

                            src={logo}

                            style={styles.logo}

                        />

                    )}


                    <View

                        style={styles.schoolInformation}

                    >

                        <Text

                            style={styles.schoolName}

                        >

                            {schoolName}

                        </Text>


                        <Text

                            style={styles.reportTitle}

                        >

                            STUDENT STATUS STATISTICS REPORT

                        </Text>


                        <Text

                            style={styles.academicYear}

                        >

                            Academic Year:{" "}

                            {academicYear?.name ||

                                "N/A"}

                        </Text>

                    </View>

                </View>


                {/* REPORT INFORMATION */}

                <View

                    style={styles.reportInformation}

                >

                    <View

                        style={styles.reportInfoItem}

                    >

                        <Text

                            style={styles.reportInfoLabel}

                        >

                            Grade Class:

                        </Text>


                        <Text

                            style={styles.reportInfoValue}

                        >

                            {gradeClass?.grade_class ||

                                "N/A"}

                        </Text>

                    </View>


                    <View

                        style={styles.reportInfoItem}

                    >

                        <Text

                            style={styles.reportInfoLabel}

                        >

                            Report Type:

                        </Text>


                        <Text

                            style={styles.reportInfoValue}

                        >

                            Student Status Distribution

                        </Text>

                    </View>


                    <View

                        style={styles.reportInfoItem}

                    >

                        <Text

                            style={styles.reportInfoLabel}

                        >

                            Total Students:

                        </Text>


                        <Text

                            style={styles.reportInfoValue}

                        >

                            {students.length}

                        </Text>

                    </View>

                </View>


                {/* SUMMARY */}

                <View

                    style={styles.summaryContainer}

                >

                    <View

                        style={styles.summaryBox}

                    >

                        <Text

                            style={styles.summaryLabel}

                        >

                            TOTAL STUDENTS

                        </Text>


                        <Text

                            style={styles.summaryValue}

                        >

                            {students.length}

                        </Text>

                    </View>


                    <View

                        style={styles.summaryBox}

                    >

                        <Text

                            style={styles.summaryLabel}

                        >

                            REGULAR

                        </Text>


                        <Text

                            style={styles.summaryValue}

                        >

                            {regularStudents.length}

                        </Text>

                    </View>


                    <View

                        style={styles.summaryBox}

                    >

                        <Text

                            style={styles.summaryLabel}

                        >

                            DEPENDENT

                        </Text>


                        <Text

                            style={styles.summaryValue}

                        >

                            {dependentStudents.length}

                        </Text>

                    </View>


                    <View

                        style={styles.summaryBoxLast}

                    >

                        <Text

                            style={styles.summaryLabel}

                        >

                            SCHOLARSHIP

                        </Text>


                        <Text

                            style={styles.summaryValue}

                        >

                            {scholarshipStudents.length}

                        </Text>

                    </View>

                </View>


                {/* REGULAR STUDENTS */}

                <StudentStatusSection

                    title="Regular Students"

                    students={regularStudents}

                />


                {/* DEPENDENT STUDENTS */}

                <StudentStatusSection

                    title="Dependent Students"

                    students={dependentStudents}

                />


                {/* SCHOLARSHIP STUDENTS */}

                <StudentStatusSection

                    title="Scholarship Students"

                    students={scholarshipStudents}

                />


                {/* FOOTER */}

                <View

                    style={styles.footer}

                    fixed

                >

                    <Text

                        style={styles.footerText}

                    >

                        {schoolName} | Student Status Statistics

                    </Text>


                    <Text

                        style={styles.footerText}

                        render={({

                            pageNumber,

                            totalPages

                        }) => (

                            `Page ${pageNumber} of ${totalPages}`

                        )}

                    />

                </View>

            </Page>

        </Document>

    );

};


export default StudentStatusSummaryPDF;